import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'spectator', pathMatch: 'full' },
  {
    path: 'spectator',
    loadComponent: () => import('./pages/spectator-home/spectator-home.component').then(m => m.SpectatorHomeComponent),
  },
  {
    path: 'spectator/tournament/:id',
    loadComponent: () => import('./pages/tournament-schedule/tournament-schedule.component').then(m => m.TournamentScheduleComponent),
  },
  {
    path: 'spectator/tournament/:id/athlete/:participantId',
    loadComponent: () => import('./pages/athlete-detail/athlete-detail.component').then(m => m.AthleteDetailComponent),
  },
  {
    path: 'spectator/tournament/:id/team/:teamId',
    loadComponent: () => import('./pages/team-detail/team-detail.component').then(m => m.TeamDetailComponent),
  },
  {
    path: 'spectator/tournament/:id/category/:categoryId',
    loadComponent: () => import('./pages/category-bracket/category-bracket.component').then(m => m.CategoryBracketComponent),
  },
  {
    path: 'spectator/tournament/:id/match/:matchId',
    loadComponent: () => import('./pages/match-detail/match-detail.component').then(m => m.MatchDetailComponent),
  },
  { path: '**', redirectTo: 'spectator' },
];
